<template>
  <v-dialog :wxid="$options.name" v-model="modalDialog" fullscreen>
    <template #activator="{ on: dialog, attrs }">
      <wx-btn-standard
        v-bind="attrs"
        v-on="{ ...dialog }"
        :title="$t('dashboard.productionRun.newProductionRunBtnHoverTitle')"
        :disabled="isPresenter"
        :class="btnCssClass"
        class="add-production-run"
        color="primary"
      >
        <v-icon left>mdi-plus</v-icon>
        <span class="text-string">{{ $t("dashboard.productionRun.newProductionRunBtn") }}</span>
      </wx-btn-standard>
    </template>

    <article class="v-dialog__content">
      <header>
        <v-btn icon large @click="closeModalDialog" :title="$t('common.dialogFormCancelHoverTitle')" class="close-btn">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <h2 class="mb-2 md-8 wx-typo-h1">{{ $t("dashboard.productionRun.newTitle") }}</h2>
      </header>

      <production-run-form ref="productionRunForm" @close="closeModalDialog" @submit="submitProductionRun" />
    </article>
  </v-dialog>
</template>

<script>
import WxBtnStandard from "@/components/ui/WxBtnStandard";
import { mapActions, mapGetters } from "vuex";
import ProductionRunForm from "@/components/dashboard/productionRun/ProductionRunForm.vue";

export default {
  name: "CreateProductionRunDialog",
  components: {
    ProductionRunForm,
    WxBtnStandard,
  },
  props: {
    btnCssClass: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      modalDialog: false,
    };
  },
  computed: {
    ...mapGetters("user", ["isPresenter"]),
  },
  methods: {
    ...mapActions("dashboard", ["createProductionRun"]),
    submitProductionRun(submission) {
      const formattedSubmission = {
        sku: submission.sku,
        work_order_number: submission.workOrder,
        lot_number: submission.lotNumber,
        number_of_employees: submission.numberOfEmployees,
        planned_quantity: submission.plannedQuantity,
        effective_start_time: submission.startTime,
      };
      this.createProductionRun(formattedSubmission).then(this.closeModalDialog);
    },
    closeModalDialog() {
      this.$refs.productionRunForm.reset();
      this.modalDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-dialog {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-base-theme);

  &__content {
    display: flex;
    align-items: center;
    flex-flow: column nowrap;
    position: initial;
    left: auto;
    width: 100%;
    max-width: 600px;
    padding-inline: var(--grid-gutter);
    pointer-events: auto;

    header {
      padding-top: var(--grid-gutter);

      .close-btn {
        position: fixed;
        z-index: 1; // hover fields
        top: var(--dialog-close-offset);
        right: var(--dialog-close-offset);
      }
    }
    .v-form {
      width: 100%;

      fieldset {
        border: none;

        &.form-footer-actions {
          display: flex;
          justify-content: flex-end;
          column-gap: var(--btn-inline-margin);
          padding-bottom: var(--grid-gutter);
        }
      }

      // Responsive Columns
      .row {
        margin-top: 0;
        margin-bottom: 0;
        .field-col {
          padding-top: 0;
          padding-bottom: 0;
        }
      }
    }
  }
}
</style>
